import React, { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Select from "react-select";
import PropTypes from "prop-types";
import "./SideDrawer.css";
import axios from "axios";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";
import SoftInput from "components/SoftInput";
import { DatePicker } from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;

const SideDrawer = (props) => {
  const {
    setOpen,
    statefilter,
    setStatefilter,
    districtfilter,
    setDistrictfilter,
    datefilter,
    setDatefilter,
    resetfunc,
    jffilter,
    setJffilter,
    table,
    educationfilter,
    setEducationfilter,
    rolefilter,
    setRolefilter,
    degreefilter,
    setDegreefilter,
    boardingfilter,
    setBoardingfilter,
    setFunc,
    fetchFilteredCandidates,
  } = props;
  let drawerClasses = "side-drawer";
  if (props.show) {
    drawerClasses = "side-drawer open";
  }

  const TermSlider = createMuiTheme({
    overrides: {
      MuiSlider: {
        root: {
          color: "#52af77",
          height: 8,
        },
        thumb: {
          height: 24,
          width: 24,
          backgroundColor: "#fff",
          border: "2px solid currentColor",
          marginTop: -8,
          marginLeft: -12,
          "&:focus,&:hover,&$active": {
            boxShadow: "inherit",
          },
        },
        active: {},
        valueLabel: {
          left: "calc(-50% + 4px)",
        },
        track: {
          height: 8,
          borderRadius: 4,
        },
        rail: {
          height: 8,
          borderRadius: 4,
        },
      },
    },
  });

  const handleAgeChange = (event, newValue, activeThumb) => {
    // setAge(newValue === "" ? 26 : newValue);
    if (!Array.isArray(newValue)) {
      return;
    }

    if (newValue[1] - newValue[0] < 10) {
      if (activeThumb === 0) {
        const clamped = Math.min(newValue[0], 65 - 10);
        console.log("age slider:", [clamped, clamped + 10]);
        setBoardingfilter([clamped, clamped + 10]);
      } else {
        const clamped = Math.max(newValue[1], 10);
        console.log("age slider:", [clamped - 10, clamped]);
        setBoardingfilter([clamped - 10, clamped]);
      }
    } else {
      console.log("age slider:", newValue);
      setBoardingfilter(newValue);
    }
  };

  const [selectedFilterState, setSelectedFilterState] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterDistrict, setFilterDistrict] = useState("");
  const [multiDistrict, setMultiDistrict] = useState([]);
  const [jobrole, Setjobrole] = useState();
  const [education, Seteducation] = useState();
  const [degree, Setdergee] = useState();
  const [multiEducation, setMultiEducation] = useState([]);
  const [multiRole, setMultiRole] = useState([]);
  const [multiSpecialization, setMultiSpecialization] = useState([]);
  const [multigender, setMultigender] = useState([]);

  const genderOption = [
    {
      label: "Male",
      value: "Male",
    },
    {
      label: "Female",
      value: "Female",
    },
    // {
    //   label: "All",
    //   value: "All",
    // },
  ];

  const option1 = [
    //WA status
    // { label: "Whatsapp Verification in Progress", value: "Whatsapp Verification in Progress" },
    // { label: "Whatsapp Verified", value: "Whatsapp Verified" },
    // { label: "Read", value: "Read" },
    // { label: "deliverd", value: "deliverd" },
    // call status
    { label: "Bot yet to engage", value: "Bot yet to engage" },
    { label: "Bot successfully engaged", value: "Bot successfully engaged" },
    {
      label: "Not Answered/Ringing",
      value: "Not Answered/Ringing",
    },
    {
      label: "Call Disconnected without conversation",
      value: "Call Disconnected without conversation",
    },
    {
      label: "Wrong Number",
      value: "Wrong Number",
    },
    {
      label: "Switched Off",
      value: "Switched Off",
    },
    {
      label: "Answered",
      value: "Answered",
    },
    // job status
    {
      label: "Actively looking for job",
      value: "Actively looking for job",
    },
    {
      label: "Can consider a new job ",
      value: "Can consider a new job ",
    },
    {
      label: "Not looking for job now",
      value: "Not looking for job now",
    },
    {
      label: "Not looking for job in the long run",
      value: "Not looking for job in the long run",
    },
    // ready resume
    // next step status
    {
      label: "Placeable Now",
      value: "Placeable Now",
    },
    {
      label: "Not Placeable",
      value: "Not Placeable",
    },
    {
      label: "Shortlisted for future",
      value: "Shortlisted for future",
    },
    // jpStatus
    {
      label: "CV Shared with Client",
      value: "CV Shared with Client",
    },
    {
      label: "CV Shortlisted by Client",
      value: "CV Shortlisted by Client",
    },
    {
      label: "Interview Scheduled by Client",
      value: "Interview Scheduled by Client",
    },
    {
      label: "Client Rejected by Candidate",
      value: "Client Rejected by Candidate",
    },
    {
      label: "CV Rejected by Client",
      value: "CV Rejected by Client",
    },
    // interviewStatus
    {
      label: "First Round of Interview done ",
      value: "First Round of Interview done ",
    },
    {
      label: "Final Rounds of Interview done",
      value: "Final Rounds of Interview done",
    },
    {
      label: "Rejected in First Round ",
      value: "Rejected in First Round ",
    },
    {
      label: "Rejected in Later Rounds",
      value: "Rejected in Later Rounds ",
    },
    {
      label: "Rejected by Candidate",
      value: "Rejected by Candidate",
    },
    {
      label: "Shortlisted",
      value: "Shortlisted",
    },
    // selectedStatus
    {
      label: "Selected by Client",
      value: "Selected by Client",
    },
    {
      label: "Rejected by Client",
      value: "Rejected by Client",
    },
    {
      label: "Rejected by Candidate",
      value: "Rejected by Candidate",
    },
    {
      label: "Rejected in Later Rounds",
      value: "Rejected in Later Rounds ",
    },
    {
      label: "Accepted by Candidate",
      value: "Accepted by Candidate",
    },
    // joiningStatus
    {
      label: "Joining Date Awaited",
      value: "Joining Date Awaited",
    },
    {
      label: "Joining Date Given ",
      value: "Joining Date Given ",
    },
    {
      label: "Joining Done",
      value: "Joining Done",
    },
    {
      label: "Joining Rejected by Candidate",
      value: "Joining Rejected by Candidate",
    },
    {
      label: "Joining Rejected by Candidate",
      value: "Joining Rejected by Candidate",
    },
    // retentionStatus
    {
      label: "Positive Feedback by Client and Employee",
      value: "Positive Feedback by Client and Employee",
    },
    {
      label: "Neutral Feedback by Client and Employee",
      value: "Neutral Feedback by Client and Employee",
    },
    {
      label: "Negative Feedback by Client",
      value: "Negative Feedback by Client",
    },
    {
      label: "Negative Feedback by Employee ",
      value: "Negative Feedback by Employee ",
    },
    {
      label: "Status Unclear",
      value: "Status Unclear",
    },
  ];

  const option2 = [
    { value: "Onboarded", label: "Onboarded" },
    { value: "Not Onboarded", label: "Not Onboarded" },
  ];

  const InternshipStatus = [
    { label: "Applied", value: "Applied" },
    { label: "Under Verification", value: "Under Verification" },
    { label: "Selected", value: "Selected" },
    { label: "Joined", value: "Joined" },
  ];

  useEffect(() => {
    if (districtfilter === "") {
      setMultiDistrict([]);
    }
  }, [districtfilter]);

  useEffect(() => {
    if (rolefilter === "") {
      setMultigender([]);
    }
  }, [rolefilter]);

  useEffect(() => {
    if (jffilter === "") {
      setMultiEducation([]);
    }
  }, [jffilter]);

  const stylesDD = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      // borderColor: state.isFocused ? "grey" : "red",
      fontSize: "14px",
    }),
    option: (base) => ({
      ...base,
      // border: `1px dotted red`,
      height: "100%",
      fontSize: "14px",
    }),
  };

  const fetchStateList = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/state`)
      .then((res) => {
        //   setState(res.data);
        setFilterState(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const fetchDistricts = () => {
    const params = {
      state: statefilter,
    };
    const paramString = new URLSearchParams(params).toString();
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/district?${paramString}`
        // {
        //   state: selectedState,
        // }
      )
      .then((res) => {
        //   setDistrict(res.data);
        setFilterDistrict(res.data);
        // setSelectedFilterDistrict(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetcheducation = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/qualification`)
      .then((res) => {
        Seteducation(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const fetchdegree = () => {
    axios
      // .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/specialization`)
      .get(`${process.env.REACT_APP_JOB_URL}/generic/degree`)
      .then((res) => {
        Setdergee(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const fetchjobrole = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/generic/designation`)
      .then((res) => {
        Setjobrole(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    fetchStateList();
    fetcheducation();
    fetchdegree();
    fetchjobrole();
  }, []);

  useEffect(() => {
    fetchDistricts();
  }, [statefilter]);

  function onCalendarChange(dates) {
    setDatefilter(
      dates?.map((v) => moment(new Date(v)).format("YYYY-MM-DD")),
      "onCalendarChange"
    );
  }
  console.log("table num::", table);
  return (
    <div className={drawerClasses}>
      <SoftBox
        sx={{
          height: "90%",
          backgroundColor: "#FFF",
          // borderBottom: "1px solid black",
          // borderRadius: "2px",
          cursor: "pointer",
          //   overFlowY: "scroll",
        }}
        display="flex"
        justifyContent="center"
        alignItems="center"
        // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
        width="100%"
      >
        <SoftBox
          width="100%"
          sx={{
            height: "100%",
            backgroundColor: "#FFF",
            // borderBottom: "1px solid black",
            // borderRight: "1px solid black",
            // borderRadius: "2px",
            cursor: "pointer",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* <SoftBox>Welcome filter</SoftBox> */}
          <SoftBox
            display="flex"
            justifyContent="space-between"
            // justifyConten="flex-end"
            alignItems="left"
            sx={{
              // height: "100%",
              backgroundColor: "#FFF",
              //   borderBottom: "1px solid black",
              // borderRight: "1px solid black",
              // borderRadius: "2px",
              padding: "0px 20px",
              cursor: "pointer",
            }}
          >
            <SoftTypography>Quick Filter</SoftTypography>
            <SoftBox onClick={() => props.setOpen(false)}>
              {" "}
              {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                <path
                  d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 
                  13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                ></path>
              </svg>{" "} */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ height: "20px" }}
              >
                <path
                  d="M12.0007 10.5865L16.9504 5.63672L18.3646 7.05093L13.4149 12.0007L18.3646 16.9504L16.9504 18.3646L12.0007 
                              13.4149L7.05093 18.3646L5.63672 16.9504L10.5865 12.0007L5.63672 7.05093L7.05093 5.63672L12.0007 10.5865Z"
                ></path>
              </svg>
            </SoftBox>
          </SoftBox>

          <SoftBox height="450px" padding="8px">
            <SoftBox margin="8px">
              <SoftTypography fontSize="15px" fontWeight="small" lineHeight="19px">
                Date
              </SoftTypography>

              <RangePicker
                style={{ width: "100%" }}
                // value={datefilter}
                onCalendarChange={onCalendarChange}
              />
            </SoftBox>

            <SoftBox margin="8px">
              <SoftTypography fontSize="15px" fontWeight="small" lineHeight="19px">
                State
              </SoftTypography>

              <Select
                placeholder="Search...."
                isClearable
                value={statefilter !== "" ? { label: statefilter, value: statefilter } : null}
                // options={stateData}
                options={filterState}
                onChange={(e) => (e ? setStatefilter(e.value) : setStatefilter(""))}
                styles={stylesDD}
              />
            </SoftBox>

            <SoftBox margin="8px">
              <SoftTypography fontSize="15px" fontWeight="small" lineHeight="19px">
                District
              </SoftTypography>
              <Select
                isMulti
                placeholder="Search...."
                options={filterDistrict}
                styles={stylesDD}
                value={
                  districtfilter !== "" && districtfilter !== null
                    ? districtfilter?.split(",").map(
                        (ele) =>
                          ele !== "null" && {
                            label: ele,
                            value: ele,
                          }
                      )
                    : multiDistrict
                }
                onChange={(e) => {
                  if (e) {
                    setMultiDistrict(e.map((item) => item));
                  } else {
                    setMultiDistrict([]);
                  }
                  setDistrictfilter(
                    e
                      .map((ele) => ele)
                      .map((item) => item.value)
                      .join()
                  );
                }}
              />
            </SoftBox>

            <SoftBox margin="8px">
              <SoftTypography fontSize="15px" fontWeight="small" lineHeight="19px">
                Status
              </SoftTypography>

              <Select
                placeholder="Search...."
                isClearable
                isMulti
                options={table === 3 ? InternshipStatus : option1}
                value={
                  jffilter !== ""
                    ? jffilter?.split(",").map(
                        (ele) =>
                          ele !== "null" && {
                            label: ele,
                            value: ele,
                          }
                      )
                    : multiEducation
                }
                onChange={(e) => {
                  if (e) {
                    setMultiEducation(e.map((item) => item));
                  } else {
                    setMultiEducation([]);
                  }
                  setJffilter(
                    e
                      .map((ele) => ele)
                      .map((item) => item.value)
                      .join()
                  );
                }}
                styles={stylesDD}
              />
            </SoftBox>

            <SoftBox margin="8px">
              <SoftTypography fontSize="15px" fontWeight="small" lineHeight="19px">
                Gender
              </SoftTypography>

              <Select
                isClearable
                isMulti
                options={genderOption}
                value={
                  rolefilter !== ""
                    ? rolefilter?.split(",").map(
                        (ele) =>
                          ele !== "null" && {
                            label: ele,
                            value: ele,
                          }
                      )
                    : multigender
                }
                onChange={(e) => {
                  if (e) {
                    setMultigender(e.map((item) => item));
                  } else {
                    setMultigender([]);
                  }
                  setRolefilter(
                    e
                      .map((ele) => ele)
                      .map((item) => item.value)
                      .join()
                  );
                }}
                styles={stylesDD}
              />
              {/* <SoftInput type="text"  placeholder="Search...." width="128px" height="32px" sx={{borderRadius:"100px",marginTop:"10px",border:"1px solid #3B5092",backgroundColor:"#F5F5F5"}} /> */}
            </SoftBox>

            {/* <SoftBox margin="8px">
              <SoftTypography fontSize="15px" fontWeight="small" lineHeight="19px">
                {/* Age: {age} *
                Age: {`${boardingfilter[0]} - ${boardingfilter[1]}`}
              </SoftTypography>
              <ThemeProvider theme={TermSlider}>
                <Slider
                  // name="termValue"
                  getAriaLabel={() => "Minimum distance shift"}
                  valueLabelDisplay="auto"
                  // aria-label="Default"
                  // defaultValue={[26 - 36]}
                  min={18}
                  max={65}
                  value={boardingfilter}
                  disableSwap
                  onChange={handleAgeChange}
                />
              </ThemeProvider>
              {/* <SoftInput type="text"  placeholder="Search...." width="128px" height="32px" sx={{borderRadius:"100px",marginTop:"10px",border:"1px solid #3B5092",backgroundColor:"#F5F5F5"}} /> 
            </SoftBox> */}
          </SoftBox>

          <SoftBox
            display="flex"
            flexDirection="row"
            justifyContent="center"
            gap="35px"
            px={3}
            py="24px 0px"
          >
            <SoftBox
              sx={{
                height: "40px",
                backgroundColor: "#3B5092",
                borderRadius: "100px",
                cursor: "pointer",
              }}
              // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
              // p="10px 25px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              width={{ lg: "150px", sm: "100%", xs: "50%" }}
              onClick={() => {
                setOpen(false);
                resetfunc();
              }}
            >
              <SoftTypography
                display="flex"
                justifyContent="center"
                sx={{
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: "small",
                  lineHeight: "20px",
                }}
              >
                Reset
              </SoftTypography>
            </SoftBox>
            <SoftBox
              sx={{
                height: "40px",
                backgroundColor: "#3B5092",
                borderRadius: "100px",
                cursor: "pointer",
              }}
              // p={{ lg: "10px ", sm: "10px", xs: "10px" }}
              // p="10px 25px"
              display="flex"
              justifyContent="center"
              alignItems="center"
              width={{ lg: "150px", sm: "100%", xs: "50%" }}
              onClick={() => {
                setOpen(false);
                setFunc(), fetchFilteredCandidates();
              }}
            >
              <SoftTypography
                display="flex"
                justifyContent="center"
                sx={{
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: "small",
                  lineHeight: "20px",
                }}
              >
                Apply Filter
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </div>
  );
};

SideDrawer.propTypes = {
  show: PropTypes.boolean,
  setOpen: PropTypes.boolean,
  statefilter: PropTypes.string,
  setStatefilter: PropTypes.string,
  districtfilter: PropTypes.string,
  setDistrictfilter: PropTypes.string,
  datefilter: PropTypes.string,
  setDatefilter: PropTypes.string,
  resetfunc: PropTypes.func,
  jffilter: PropTypes.string,
  setJffilter: PropTypes.string,
  table: PropTypes.table,
  educationfilter: PropTypes.string,
  setEducationfilter: PropTypes.string,
  rolefilter: PropTypes.string,
  setRolefilter: PropTypes.string,
  degreefilter: PropTypes.string,
  setDegreefilter: PropTypes.string,
  boardingfilter: PropTypes.string,
  setBoardingfilter: PropTypes.string,
  setFunc: PropTypes.func,
  fetchFilteredCandidates: PropTypes.func,
};

export default SideDrawer;
